import { Expose } from "class-transformer";

export class AssignPlanningBoardUserDto {
  @Expose()
  planningBoardProjectId: string;

  @Expose()
  userId: string;
}
